import React from 'react';
import List from '@material-ui/core/List';

import { ContactSummaryRow } from './contact-summary-row.component';
import { IContactSummary } from './player-contact.types';

interface IContactSummaryListProps {
  contacts: IContactSummary[];
}

// Read-only roster of contacts on a player. Deliberately not editable: a parent
// may only edit the PlayerContact rows their own credentials claim.
export const ContactSummaryList: React.FC<IContactSummaryListProps> = ({ contacts }) => (
  <List dense disablePadding>
    {contacts.map((contact, index) => (
      <ContactSummaryRow key={contact._id || index} contact={contact} disableGutters />
    ))}
  </List>
);
